import React from 'react'
import Block from './Block'

const Theory = ({ children }) => (
  <Block tint={0} icon={'book'} header="Theory">
    {children}
  </Block>
)

export default Theory



// WEBPACK FOOTER //
// ./src/components/Theory.js